import React from "react";
import {Breadcrumbs} from "@mui/material";
import {BreadContainer, Content} from "./styles";

export function BreadLayout() {

  return(
    <BreadContainer>
      <Breadcrumbs aria-label="breadcrumb">
          <Content>
            {window.location.pathname.split("/").map((val, index, array) => {
              let breadcrumbs = val.charAt(0).toUpperCase() + val.slice(1) + " ";

              if (index > 0 && index != array.length - 1) {
                breadcrumbs = breadcrumbs + " / ";
              }

              return breadcrumbs;
            })}
          </Content>
      </Breadcrumbs>
    </BreadContainer>
  );
}
